import React from "react";
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  SimpleForm,
  TextInput,
  Edit,
  Create,
  SimpleShowLayout,
  Show,
} from "react-admin";

export const FeedSourcesList = props => (
  <List {...props}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="url" />
      <EditButton />
    </Datagrid>
  </List>
);
export const FeedSourcesEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled source="id" />
      <TextInput source="title" />
      <TextInput source="url" />
    </SimpleForm>
  </Edit>
);
export const FeedSourcesCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="title" />
      <TextInput source="url" />
    </SimpleForm>
  </Create>
);
export const FeedSourcesShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="title" />
      <TextField source="url" />
    </SimpleShowLayout>
  </Show>
);
